import type { ISectionComponentProps } from '@components/ReportContent/types';

import CreativesSectionContent from './CreativesSectionContent';

const CreativesSection = ({ sectionData }: ISectionComponentProps) => {
  // Check that the section data has creatives
  if (!('data' in sectionData) || !('creatives' in sectionData.data)) {
    return <div>Error: Invalid data for Creatives section.</div>;
  }

  return <CreativesSectionContent creativesData={sectionData.data.creatives} />;
};

export default CreativesSection;
